export enum MarkupFormula { None = -1, OpenAndClose = 0, Pnl = 1, MarginOpenAndClose = 2 };
